var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector 4","d":"M8.5 1L1 8.5L8.5 16","stroke":"#382E2B"}));
}

ChevronLeft.defaultProps = {"width":"9","height":"17","viewBox":"0 0 9 17","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
